import { ReactElement, useCallback, useEffect, useState } from 'react';

import { MatchIdConnectionProvider } from 'modules/auth/components/MatchIdConnectionProvider';
import { ReownButton } from 'modules/auth/components/ReownButton';
import { ReownConnectionProvider } from 'modules/auth/components/ReownConnectionProvider';
import { KnownDialogs, useDialog } from 'modules/dialogs';
import { Dialog } from 'modules/dialogs/components/Dialog';
import { globalTranslation } from 'modules/i18n';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { useConnection } from '../../hooks/useConnection';
import { MatchIdButton } from '../MatchIdButton';
import { MatchIdLoginOptions } from '../MatchIdLoginOptions';
import { useStyles } from './useStyles';

export function WalletsDialog(): ReactElement {
  const { isOpened, onClose } = useDialog(KnownDialogs.connect);
  const { t, keys } = useTranslation(globalTranslation);
  const { classes } = useStyles();
  const [showMatchIdOptions, setShowMatchIdOptions] = useState(false);

  const { isConnected } = useConnection();

  const handleClose = useCallback(() => {
    onClose();
    setShowMatchIdOptions(false);
  }, [onClose]);

  useEffect(() => {
    if (isConnected && isOpened) {
      handleClose();
    }
  }, [handleClose, isConnected, isOpened]);

  return (
    <Dialog
      keepMounted
      open={isOpened}
      title={
        showMatchIdOptions
          ? t(keys.common.connectMatchID)
          : t(keys.common.connectWallet)
      }
      onClose={handleClose}
    >
      <div>
        <MatchIdConnectionProvider>
          {showMatchIdOptions && (
            <MatchIdLoginOptions
              onBackClick={() => setShowMatchIdOptions(false)}
              onClose={handleClose}
            />
          )}
        </MatchIdConnectionProvider>

        <ReownConnectionProvider>
          {!showMatchIdOptions && (
            <div className={classes.wallets}>
              <MatchIdButton onClick={() => setShowMatchIdOptions(true)} />

              <ReownButton />
            </div>
          )}
        </ReownConnectionProvider>
      </div>
    </Dialog>
  );
}
